import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { setContext } from "apollo-link-context";
import { getToken } from "./msal";

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_BACKEND_URL || "http://localhost:4000",
});

const authMiddleware = setContext(async (_req, { headers }) => {
  const hardcodedToken = localStorage.getItem("tkn");
  const currentToken = hardcodedToken || (await getToken());

  if (currentToken) {
    return {
      headers: {
        ...headers,
        authorization: `Bearer ${currentToken}`,
      },
    };
  }

  return { headers };
});

const selectedPlantMiddleware = setContext(async (_req, { headers }) => {
  const currentPlant = localStorage.getItem("plantid");
  if (currentPlant) {
    return {
      headers: {
        ...headers,
        plantid: currentPlant,
      },
    };
  }
  return { headers };
});

const linkWithAuthenticationHeader = from(
  [authMiddleware, selectedPlantMiddleware, httpLink].filter(
    Boolean
  ) as ApolloLink[]
);
export const apolloClient = new ApolloClient({
  link: linkWithAuthenticationHeader,
  cache: new InMemoryCache({
    typePolicies: {
      ProductionDestination: {
        keyFields: ["name", "code"],
      },
      Query: {
        fields: {
          plantReports: {
            keyArgs: ["params", ["status"]],
            merge(
              existing: { nodes: { __ref: string }[] } = { nodes: [] },
              incoming: { nodes: { __ref: string }[] } = { nodes: [] }
            ) {
              const refs = Array.from(
                new Set([
                  ...existing.nodes.map((e) => e.__ref),
                  ...incoming.nodes.map((e) => e.__ref),
                ])
              ).map((ref) => ({ __ref: ref }));
              return {
                ...incoming,
                nodes: refs,
              };
            },
          },
        },
      },
    },
  }),
  connectToDevTools: true,
});

new HttpLink();
